import React from 'react';

const MissionBearcatsHubOverview = () => {
    return (
        <div className="document">
            <h1><img src="/guide-images/Bearcat_Logo.png" alt="Bearcat" style={{height: '1.8em', verticalAlign: 'middle', marginRight: '10px'}} /> NoCode Hackathon Mission</h1>
            <p>
                Your mission is to use NYX NoCode to create innovative content that showcases and celebrates everything that makes
                Mena School District special—from clubs and sports to events and community activities.
            </p>

            <h2>Bearcats Hub Overview</h2>
            <p>
                The Mena School District NoCode Hackathon is all about building community around school activities. Here's why your
                project matters and how it will contribute to the Bearcats Hub.
            </p>

            <h3>The Bearcats Hub Project</h3>
            <p>
                <strong>What is it?</strong><br />
                The Bearcats Hub is an initiative to celebrate and promote all the amazing activities happening at Mena School District.
                From sports teams and academic clubs to special events and student achievements, the Bearcats Hub is your platform to
                showcase what makes our school community vibrant and exciting.
            </p>
            <p>
                <strong>Project Goals</strong>
                <ul>
                    <li>Build school spirit and community pride around Mena School District activities.</li>
                    <li>Showcase clubs, sports teams, events, and student achievements to the school and broader community.</li>
                    <li>Create engaging, interactive ways for students, families, and community members to connect with school activities.</li>
                    <li>Encourage student creativity and innovation through technology.</li>
                    <li>Provide a central hub for information about everything happening at Mena School District.</li>
                </ul>
            </p>

            <h2>Your Role in Building the Bearcats Hub</h2>
            <p>
                <strong>How Your Project Helps</strong><br />
                By using NYX NoCode to create apps, websites, games, and interactive features, you're helping build excitement around
                school activities and making it easier for everyone to stay connected with what's happening at Mena School District.
            </p>
            <p>
                <strong>Think Creatively!</strong><br />
                Your projects don't have to be simple information pages. Think about interactive, fun, and engaging ways to promote
                activities. Here are some creative examples to inspire you:
            </p>
            <p>
                <strong>Creative Project Ideas</strong>
                <ul>
                    <li><strong>Speech Club Stage Fright Game:</strong> An interactive game that helps students practice public speaking
                    skills and overcome stage fright, promoting the speech and debate club in a fun way.</li>
                    <li><strong>Basketball Cheer Machine:</strong> An interactive app that lets fans create custom cheers, play sound effects,
                    or learn new chants to support the basketball team.</li>
                    <li><strong>Club Finder Quiz:</strong> A fun personality quiz that helps students discover which clubs match their interests.</li>
                    <li><strong>Event Countdown Timer:</strong> Animated countdown displays for upcoming school events like homecoming,
                    prom, or big game days.</li>
                    <li><strong>Achievement Gallery:</strong> An interactive showcase of student accomplishments in academics, arts,
                    athletics, and community service.</li>
                    <li><strong>Virtual Spirit Week:</strong> Interactive activities and challenges that build school spirit online.</li>
                    <li><strong>Music Note Game:</strong>A skill game where you name music notes can help build interest in band or choir.</li>
                    <li><strong>Band Performance Visualizer:</strong> Create visual animations that sync with the school band's music.</li>
                    <li><strong>Sports Stats Tracker:</strong> Interactive displays showing team statistics, player profiles, and game schedules.</li>
                    <li><strong>Drama Club Preview:</strong> Interactive teasers for upcoming theater productions with character bios and
                    behind-the-scenes content.</li>
                    <li><strong>STEM Club Experiments:</strong> Interactive simulations or demonstrations of cool science experiments.</li>
                </ul>
            </p>

            <h2>What Can You Build?</h2>
            <p>
                The possibilities are endless! You can create:
                <ul>
                    <li>Interactive games and simulations</li>
                    <li>Animated presentations and visual showcases</li>
                    <li>Information hubs and event calendars</li>
                    <li>Virtual tours and 3D visualizations</li>
                    <li>Quizzes, polls, and interactive surveys</li>
                    <li>Audio/visual content and multimedia experiences</li>
                    <li>And anything else you can imagine!</li>
                </ul>
            </p>

            <h2>Remember: Push the Boundaries!</h2>
            <p>
                The best projects will be creative, engaging, and show off what makes Mena School District special. Don't just make
                a simple webpage—think about how to make your project interactive, fun, and memorable. Use the full range of NYX NoCode's
                tools: Prompt Pad for generating content, Doodle Pad for custom artwork, 3D Pad for animations, Speech Pad for audio,
                Video Pad for multimedia, and combine them in creative ways!
            </p>

            <p>
                Ask yourself: What would make someone excited to learn about this activity? What would make them want to participate as a team member or a booster?
                What would make them proud to be a Bearcat?
            </p>

            <h2>Get Creative and Have Fun!</h2>
            <p>
                This is your chance to showcase your creativity, learn new skills, and contribute to your school community.
                Don't be afraid to try bold ideas—Justin Bearcat is here to help you every step of the way!
            </p>

            <p style={{marginTop: '40px', fontStyle: 'italic', textAlign: 'center'}}>
                Let's show the world what Bearcats can do!
            </p>

            <div style={{textAlign: 'center', marginTop: '30px'}}>
                <img src="/guide-images/Bearcat_Logo.png" alt="Bearcat" style={{height: '100px'}} />
            </div>
        </div>
    );
};

export default MissionBearcatsHubOverview;
